import {ValueObject} from '@s-ui/domain'

export class ImagesListValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {Array} params.items
   * */
}
